export default {
  fullName: {
    id: 'global_full_name',
    defaultMessage: '{firstName} {lastName}',
  },
  seeDetails: {
    id: 'bo_sellers-orders-components-orders_table-see-order-details',
    defaultMessage: 'see details',
  },
} as const
